import { LinearGradient } from "expo-linear-gradient";
import React from "react";
import { Dimensions, StyleSheet, Text, TouchableOpacity } from "react-native";
import { RFPercentage, RFValue } from "react-native-responsive-fontsize";

const { width, height } = Dimensions.get("window");

const GradientButton = ({
  text,
  onPress,
  textStyle,
  disabled,
  gradientStyle,
}) => {
  const colors = ["#9d7838", "#eee4a5", "#9d7838"];
  const disabledColors = ["gray", "gray", "gray"];

  return (
    <TouchableOpacity
      onPress={onPress ? onPress : null}
      activeOpacity={0.8}
      disabled={disabled ? disabled : false}
    >
      <LinearGradient
        colors={disabled ? disabledColors : colors}
        start={[0, 0.5]}
        end={[1, 0.5]}
        style={gradientStyle ? gradientStyle : styles.gradient}
      >
        <Text style={textStyle ? textStyle : styles.buttonText}>{text}</Text>
      </LinearGradient>
    </TouchableOpacity>
  );
};

export default GradientButton;

const styles = StyleSheet.create({
  buttonText: {
    backgroundColor: "transparent",
    fontSize: RFValue(16),
    fontFamily: "avenir",
  },
  gradient: {
    alignItems: "center",
    borderRadius: 5,
    width: width * 0.485,
    marginVertical: 10,
    paddingVertical: 10,
  },
});
